<template>
    <div>
        <div class="pt-4">
            <div class="jumbotron bg-white">
                <h2 class="display-4">Add Floor Plan Here</h2>
                <p class="lead"> Please choose image/png ,image/jpeg , image/jpg , image/svg </p>
                <hr class="my-4">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <button class="input-group-text" v-on:click="submitFile()" v-bind:disabled="postData.name.length < 1">Submit</button>
                    </div>
                    <div class="custom-file">
                        <input type="file"
                               id="file"
                               class="custom-file-input"
                               accept="image/svg+xml,image/png,image/jpeg,image/jpg"
                               ref="file"
                               v-on:change="handleFileUpload($refs.file, postData)"/>
                        <label class="custom-file-label" for="file">{{postData.name ? postData.name : 'Choose file'}}</label>
                    </div>
                </div>
            </div>

            <hr>

            <transition name="fade">
                <div class="alert alert-success" v-if="response.isSuccess">
                    <p class="text-center"> The Floor plan has been added to the building</p>
                </div>
            </transition>
            <transition name="fade">
            <div class="alert alert-success" v-if="response.isSuccessReplace">
                <p class="text-center">Floor plan has been successfully updated</p>
            </div>
        </transition>
            <transition name="fade">
                <div class="alert alert-danger" v-if="response.isFileOfLargeSize">
                    <p class="text-center">File Size too Large. Please reduce the file size</p>
                </div>
            </transition>
            <transition name="fade">
                <div class="alert alert-danger" v-if="response.isError">
                    <p  class="text-center">{{errorMessage}}</p>
                </div>
            </transition>
        </div>
        <div>
            <div v-for="(floorPlan,index) in floorPlans">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <button class="input-group-text" v-on:click="replaceFile(floorPlan, index)" v-bind:disabled="floorPlan.postData.name.length < 1">Replace</button>
                    </div>
                    <div class="custom-file">
                        <input type="file" class="custom-file-input"
                               v-bind:id="floorPlan.id"
                               accept="image/svg+xml,image/png,image/jpeg,image/jpg"
                               :ref="`${floorPlan.id}`"
                               v-on:change="handleFileUpload($refs[floorPlan.id][0], floorPlan.postData)"/>
                        <label class="custom-file-label" v-bind:for="floorPlan.id">{{floorPlan.postData.name ? floorPlan.postData.name : 'Choose file'}}</label>
                    </div>
                </div>
                <div class="position-relative imgContainer">
                    <img :src="returnedUrl(floorPlan)" width="100%">
                    <button class="btn btn-danger" v-on:click="confirmPopup('Delete Floor Plan',floorPlan.id, index)">Delete</button>
                </div>
                <hr>
            </div>

        </div>
        <DeleteModalComponent v-if="dataToPassToModal.showModal" @close="dataToPassToModal.showModal = false"
                              :confirm="confirm" :dataToPassToModal="dataToPassToModal"
                              :dataObject="floorPlans"></DeleteModalComponent>
    </div>
</template>
<style scoped>
    .imgContainer button {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 100px;
        display: none;
    }
    .imgContainer:hover button {
        display: inline-block;
    }

</style>
<script>
  import ConnectionService from '../../../../app-model/model'
  import DeleteModalComponent from '../../../../components/modal/DeleteConfirmModalComponent.vue'
  import Vue from 'vue'

  const connectionService = new ConnectionService()
  export default {
    components: {
      DeleteModalComponent
    },
    data () {
      return {
        id: '',
        postData: {
          name: '',
          binaryFile: ''
        },
        floorPlans: [],
        response: {
          isSuccess: false,
          isError: false,
          isSuccessReplace: false,
          isFileOfLargeSize:false,
        },
        dataToPassToModal: {
          id: '',
          index: '',
          showModal: false,
        },
      }
    },
    created () {
      this.id = this.$route.params.buildingId

      this.$store.dispatch('apiResult', {
        method: 'GET',
        path: `api/buildings/${this.id}/floor-plans`,
        path_template: '/api/buildings/{building_id}/floor-plans',
        building_id:this.id
      }).then(response => {
        switch (response.status) {
          case 200:
            for(let i in response.data.data.files) {
              this.addPostDataField(response.data.data.files[i]);
            }
            this.floorPlans = response.data.data.files;

            break;
        }
      }).catch(error => {
        switch (error.response.status)
        {
          case 410:
            this.errorMessage = error.response.data.message
            connectionService['responseInTime']({
              responseObject: this.response,
              value: 'isError',
              status: true
            })
            break
        }
      })
    },
    methods: {
      addPostDataField (floorPlan) {
        Object.assign(floorPlan, {
          postData: {
            name: '',
            binaryFile: ''
          }
        });
      },
      resetPostData (postData) {
        postData.name = '';
        postData.binaryFile = '';
      },
      handleFileUpload (ref, postData) {
        let reader = new FileReader(),
            file;
        if(ref.files.length) {
          file = ref.files[0];
          postData.name = file.name;
          reader.onloadend = (evt) => {
            postData.binaryFile = evt.target.result;
          }
          reader.readAsArrayBuffer(file);
        }
        else {
          this.resetPostData(postData);
        }
      },
      submitFile () {
        this.$store.dispatch('apiResult', {
          method: 'POST',
          path: `api/buildings/${this.id}/floor-plans?name=${encodeURIComponent(this.postData.name)}`,
          data: this.postData.binaryFile,
          path_template: '/api/buildings/{building_id}/floor-plans',
          building_id:this.id
        }).then(response => {
          switch (response.status) {
            case 200:
              this.resetPostData(this.postData);
              this.addPostDataField(response.data.data);
              this.floorPlans.push(response.data.data)
              connectionService['responseInTime']({
                responseObject: this.response,
                value: 'isSuccess',
                status: true
              })
              break;
            case 422:
              this.errorMessage = response.data.message
              connectionService['responseInTime']({
                responseObject: this.response,
                value: 'isError',
                status: true
              });
              break;
          }
        }).catch(error => {
          switch(error.response.status)
          {
            case 413 :
              connectionService['responseInTime']({
                responseObject: this.response,
                value: 'isFileOfLargeSize',
                status: true
              })
              break;
          }
        })
      },
      returnedUrl (fileObject) {
        return `${fileObject.file.path}?token=${encodeURI(fileObject.file.token)}`;
      },
      confirmPopup: function (action, fileId, index) {
        this.confirm = {
          action: action,
          title: 'Are you sure to execute: ' + action,
          msg: action + ' will delete this Floor Plan',
        }
        this.dataToPassToModal.id = fileId
        this.dataToPassToModal.index = index
        this.dataToPassToModal.router = `api/buildings/${this.id}/floor-plans/`
        this.dataToPassToModal.showModal = true
        this.dataToPassToModal.pathTemplate = '/api/buildings/{building_id}/floor-plans/{file_id}'
      },
      replaceFile (floorPlan, index) {
        this.$store.dispatch('apiResult', {
          method: 'PUT',
          path: `api/buildings/${this.id}/floor-plans/${floorPlan.id}?name=${encodeURIComponent(floorPlan.postData.name)}`,
          data: floorPlan.postData.binaryFile,
          path_template: '/api/buildings/{building_id}/floor-plans/{file_id}'
        }).then(response => {
          switch (response.status) {
            case 200:
              this.addPostDataField(response.data.data);
              Vue.set(this.floorPlans, index, response.data.data);
              connectionService['responseInTime']({
                responseObject: this.response,
                value: 'isSuccess',
                status: true
              });
              break
            case 422:
              this.errorMessage = response.data.message
              connectionService['responseInTime']({
                responseObject: this.response,
                value: 'isError',
                status: true
              });
              break;
          }
        }).catch(error => {
          switch(error.response.status)
          {
            case 413 :
              connectionService['responseInTime']({
                responseObject: this.response,
                value: 'isFileOfLargeSize',
                status: true
              })
          }
        });
      }
    }
  }
</script>